import type {GridSortModel} from '@mui/x-data-grid-premium';
import type {SupplierOrdering, TransactionOrdering} from '../types/categoryProfileTypes';

const SUPPLIER_SORTABLE: Record<string, string> = {
    name: 'name', spend: 'spend', spendSharePct: 'spend', poSpend: 'poSpend', transactions: 'transactions', lastMonth: 'lastMonth',
};

/** The grid's sort model as the suppliers endpoint's `ordering` (spend, descending, by default). */
export function toSupplierOrdering(sort: GridSortModel): SupplierOrdering {
    const s = sort[0];
    const field = s ? SUPPLIER_SORTABLE[s.field] : undefined;
    if (!field) return '-spend';
    return (s.sort === 'asc' ? field : `-${field}`) as SupplierOrdering;
}

const SORTABLE: Record<string, string> = {amount: 'amount', date: 'date'};

/** The grid's sort model as the transactions endpoint's `ordering` (amount, descending, by default). */
export function toOrdering(sort: GridSortModel): TransactionOrdering {
    const s = sort[0];
    const field = s ? SORTABLE[s.field] : undefined;
    if (!field) return '-amount';
    return (s.sort === 'asc' ? field : `-${field}`) as TransactionOrdering;
}
